@let onglet = data().ongletActivite;

@if (onglet.zr_activiteSpontanee?.length) {
<p class="section-sub-title"><mat-icon>lightbulb</mat-icon>Spontanées</p>
<div class="timeline">
  @for (act of onglet.zr_activiteSpontanee; track $index) {
  @if (act.input_activite) {
  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      @if (act.input_heure) {
      <span class="time-badge secondary"><mat-icon>schedule</mat-icon>{{ act.input_heure | carnetHeure }}</span>
      }
      <span>{{ act.input_activite }}</span>
    </div>
  </div>
  }
  }
</div>
}

@if (onglet.zr_activiteDirigee?.length) {
<p class="section-sub-title"><mat-icon>flag</mat-icon>Dirigées</p>
<div class="timeline">
  @for (act of onglet.zr_activiteDirigee; track $index) {
  @if (act.input_activite) {
  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      @if (act.input_heure) {
      <span class="time-badge secondary"><mat-icon>schedule</mat-icon>{{ act.input_heure | carnetHeure }}</span>
      }
      <span>{{ act.input_activite }}</span>
    </div>
  </div>
  }
  }
</div>
}

@if (onglet.zr_sortie?.length) {
<p class="section-sub-title"><mat-icon>park</mat-icon>Sorties</p>
<div class="timeline">
  @for (sortie of onglet.zr_sortie; track $index) {
  @if (sortie.input_sortie) {
  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      @if (sortie.input_heure) {
      <span class="time-badge secondary"><mat-icon>schedule</mat-icon>{{ sortie.input_heure | carnetHeure }}</span>
      }
      <span>{{ sortie.input_sortie }}</span>
    </div>
  </div>
  }
  }
</div>
}
